module.exports = __webpack_public_path__ + "static/media/Hero_Mobile.neutral.d4fca83a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Home/photos/Hero_Mobile.neutral.jpg
// module id = 221
// module chunks = 8